import { Route, Switch } from 'react-router-dom';
import P, { InferProps } from 'prop-types';
import MatchList from './match-list';
import MatchInfo from './match-info';

function Matches({ match }: InferProps<typeof Matches.propTypes>) {
  return (
    <Switch>
      <Route path={`${match.url}/:leagueAbbrv/:season/:matchId`} component={MatchInfo} />
      <Route exact path={`${match.url}/:abbrv`} component={MatchList} />
    </Switch>
  );
}

Matches.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default Matches;
